export default __webpack_public_path__ + "static/media/sqrt.504673f6.png";